import React, { useEffect, useState } from 'react';
import Content from '../../../layout/content/Content';
import { Block, BlockHead, BlockHeadContent, BlockTitle, Button, Col, Icon, PreviewAltCard, Row, RSelect } from '../../../components/Component';
import Head from '../../../layout/head/Head';
import CardTabs from '../../components/cards/CardTabs';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { RETRIEVE_SPECIFIC_TENANT_SETTINGS_API, UPDATE_TENANT_EMAIL_CREDENTIALS_API, UPDATE_TENANT_LOGO_API, UPDATE_TENANT_SMS_CREDENTIALS_API } from '../../../api/api_data';
import { fail_retrieve_specific_tenant_settings, loading_retrieve_specific_tenant_settings, reset_retrieve_specific_tenant_settings, success_retrieve_specific_tenant_settings } from '../../../reducers/auth_tenant/retrieve_specific_tenant_settings_Slice';
import { RETRIVE_SPECIFIC_TENANT_SETTINGS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_SETTINGS_SUCCESS_MSG, UPDATE_TENANT_EMAIL_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_EMAIL_CREDENTIALS_SUCCESS_MSG, UPDATE_TENANT_LOGO_ERROR_MSG, UPDATE_TENANT_LOGO_SUCCESS_MSG, UPDATE_TENANT_SMS_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_SMS_CREDENTIALS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import * as app_consts from "../../../utils/app_consts";
import { useSelector } from 'react-redux';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { messageToast } from '../../../utils/Utils';
import { Alert, Badge, Card, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { fail_update_tenant_logo, loading_update_tenant_logo, reset_update_tenant_logo, success_update_tenant_logo } from '../../../reducers/auth_tenant/update_tenant_logo_Slice';
import TextInput from '../../components/inputs/TextInput';
import { fail_update_tenant_email_credentials, loading_update_tenant_email_credentials, reset_update_tenant_email_credentials, success_update_tenant_email_credentials } from '../../../reducers/auth_tenant/update_tenant_email_credentials_Slice';
import { fail_update_tenant_sms_credentials, loading_update_tenant_sms_credentials, reset_update_tenant_sms_credentials, success_update_tenant_sms_credentials } from '../../../reducers/auth_tenant/update_tenant_sms_credentials_Slice';
import ViewOrderApprovalsModal from '../../../components/modal/ViewOrderApprovalsModal';
import ViewDispatchNotificationsModal from '../../../components/modal/ViewDispatchNotificationsModal';
import ViewBrandsSettingsModal from '../../../components/modal/ViewBrandsSettingsModal';
import ViewStockMovementSuspensionSettingsModal from '../../../components/modal/ViewStockMovementSuspensionSettingsModal';

const initial_state = { tenant_logo: "" };
const email_provider_inital_state = { email_address: "", email_provider: "", password: "" };
const sms_provider_inital_state = { sms_provider: "", sms_sender_id: "", password: "", smpp_host: "", smpp_port: "", system_id: "", system_type: "" };


const SettingsManagement = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [settings, setSettings] = useState([]);
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const [upload_logo_modal, setUploadImageLogo] = useState(false);
  const [upload_logo_loading, setUploadLogoLoading] = useState();
  const [upload_logo_error, setUploadLogoError] = useState("");
  const [logo_settings, setLogoSettings] = useState([]);
  const [email_provider_settings, setEmailProviderSettings] = useState([]);
  const [email_provider_modal, setEmailProviderModal] = useState(false);
  const [email_provider_error, setEmailProviderError] = useState("");
  const [email_provider_loading, setEmailProiver_loading] = useState(false);
  const [email_provider_formData, setEmailProviderFormData] = useState(email_provider_inital_state);
  const [sms_provider_settings, setSmsProviderSettings] = useState([]);
  const [sms_provider_modal, setSmsProviderModal] = useState(false);
  const [sms_provider_error, setSmsProviderError] = useState("");
  const [sms_provider_loading, setSmsProiver_loading] = useState(false);
  const [sms_provider_formData, setSmsProviderFormData] = useState(sms_provider_inital_state);
  const [order_approval_settings, setOrderApprovalSettings] = useState([]);
  const [ready_for_dispatch_notifications_settings, setReadyForDispatchNotificationsSettings] = useState([]);
  const [system_brands, setSystemBrands] = useState([]);
  const [stock_movement_suspension_settings, setStockMovementSuspensionSettings] = useState([]);

  const [view_order_approval_modal, setViewOrderApprovalModal] = useState(false);
  const [view_ready_dispatch_notifications_modal, setReadyForDispatchNotifications] = useState(false);
  const [view_brands_modal, setViewBrandsModal] = useState(false);

  const [stock_movement_suspension_modal, setStockMovementSuspensionModal] = useState(false);

  const [formData, setFormData] = useState(initial_state);

  const dispatch = useDispatch();

  useEffect(() => {
    retrive_system_settings();
  }, []);

  const retrive_system_settings = () => {
    setError("");
    setLoading(true);
    dispatch(tenant_auth_actions_helper(loading_retrieve_specific_tenant_settings, success_retrieve_specific_tenant_settings, fail_retrieve_specific_tenant_settings, RETRIVE_SPECIFIC_TENANT_SETTINGS_ERROR_MSG, RETRIVE_SPECIFIC_TENANT_SETTINGS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIEVE_SPECIFIC_TENANT_SETTINGS_API}`));
  };

  // Listener
  const retrieve_specific_tenant_settings_listener = useSelector((state) => state.retrieve_specific_tenant_settings.retrieve_specific_tenant_settings);

  useEffect(() => {
    if (retrieve_specific_tenant_settings_listener.status !== app_consts.IDLE)
    {
      if (retrieve_specific_tenant_settings_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_specific_tenant_settings_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_specific_tenant_settings_listener.message);
          messageToast(retrieve_specific_tenant_settings_listener.message, app_consts.FAIL);
        } else if (retrieve_specific_tenant_settings_listener.status === app_consts.SUCCESS)
        {
          setSettings(retrieve_specific_tenant_settings_listener.data);
          // Filter Logo Settings
          const filtered_logo_settings = retrieve_specific_tenant_settings_listener.data?.tenant_settings?.find((setting) => setting?.name === app_consts.TENANT_LOGO);
          const filtered_email_provider_settings = retrieve_specific_tenant_settings_listener.data?.tenant_settings?.find((setting) => setting?.name === app_consts.TENANT_EMAIL_PROVIDER);
          const filtered_sms_provider_settings = retrieve_specific_tenant_settings_listener.data?.tenant_settings?.find((setting) => setting?.name === app_consts.TENANT_SMS_PROVIDER);
          const filtered_order_approvals = retrieve_specific_tenant_settings_listener?.data?.tenant_settings?.find((setting) => setting?.name === app_consts.ORDER_APPROVALS);
          const filtered_ready_for_dispatch_notifications = retrieve_specific_tenant_settings_listener?.data?.tenant_settings?.find((setting) => setting?.name === app_consts.READY_FOR_DISPATCH_NOFIFICATIONS);
          const filtered_brands = retrieve_specific_tenant_settings_listener?.data?.tenant_settings?.find((setting) => setting?.name === app_consts.SYSTEM_BRANDS);
          const filtered_stock_suspension = retrieve_specific_tenant_settings_listener?.data?.tenant_settings?.find((setting) => setting?.name === app_consts.STOCK_MOVEMENT_SUSPENSION);

          setLogoSettings(filtered_logo_settings);
          setEmailProviderSettings(filtered_email_provider_settings);
          setSmsProviderFormData(filtered_sms_provider_settings);
          setOrderApprovalSettings(filtered_order_approvals);
          setReadyForDispatchNotificationsSettings(filtered_ready_for_dispatch_notifications);
          setSystemBrands(filtered_brands);
          setStockMovementSuspensionSettings(filtered_stock_suspension);

          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts

        }
        dispatch(reset_retrieve_specific_tenant_settings());
      }
    }
  }, [retrieve_specific_tenant_settings_listener]);

  // Card Tabs
  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Integrations"
    },
    {
      tabName: "Miscellaneous"
    },
  ];

  const open_upload_logo_modal = () => {
    setUploadImageLogo(true);
  };

  const close_upload_logo_modal = () => {
    setUploadImageLogo(false);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file)
    {
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];

      if (!allowedTypes.includes(file.type))
      {
        messageToast("Please select a valid image file (PNG, JPEG, JPG.", app_consts.FAIL);
        return;
      }

      setFormData({ ...formData, ["tenant_logo"]: file });
    }
  };

  const handle_logo_submit = () => {
    setUploadLogoError("");
    // Update
    const sent_logo = { tenant_logo: formData?.tenant_logo };

    dispatch(tenant_auth_actions_helper(loading_update_tenant_logo, success_update_tenant_logo, fail_update_tenant_logo, UPDATE_TENANT_LOGO_ERROR_MSG, UPDATE_TENANT_LOGO_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${UPDATE_TENANT_LOGO_API}`, sent_logo));
  };

  // Listener
  const update_tenant_logo_listener = useSelector((state) => state.update_tenant_logo.update_tenant_logo);

  useEffect(() => {
    if (update_tenant_logo_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_logo_listener.status === app_consts.LOADING)
      {
        setUploadLogoLoading(true);
        setUploadLogoError("");
      } else
      {
        setUploadLogoLoading(false);
        if (update_tenant_logo_listener.status === app_consts.FAIL)
        {
          setUploadLogoError(update_tenant_logo_listener.message);
          messageToast(update_tenant_logo_listener.message, app_consts.FAIL);
        } else if (update_tenant_logo_listener.status === app_consts.SUCCESS)
        {

          retrive_system_settings();
          setUploadLogoError("");
          setFormData({ ...formData, ["tenant_logo"]: "" });
          setUploadImageLogo(false);
        }
        dispatch(reset_update_tenant_logo());
      }
    }
  }, [update_tenant_logo_listener]);

  const open_email_provider_modal = () => {
    setEmailProviderModal(true);
    setEmailProviderError("");
    setSmsProviderFormData({ ...email_provider_formData, ["email_provider"]: email_provider_settings?.settings?.email_provider, ["email_address"]: email_provider_settings?.settings?.email_address, ["password"]: "" });

  };

  const close_email_provider_modal = () => {
    setEmailProviderModal(false);
    setEmailProviderError("");
    setEmailProviderFormData({ ...email_provider_formData, ["email_provider"]: "", ["email_address"]: "", ["password"]: "" });

  };

  const handleUpdateEmailCredentials = () => {
    setEmailProviderError("");

    dispatch(tenant_auth_actions_helper(loading_update_tenant_email_credentials, success_update_tenant_email_credentials, fail_update_tenant_email_credentials, UPDATE_TENANT_EMAIL_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_EMAIL_CREDENTIALS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${UPDATE_TENANT_EMAIL_CREDENTIALS_API}`, email_provider_formData));
  };

  // Listener
  const update_tenant_email_credentials_listener = useSelector((state) => state.update_tenant_email_credentials.update_tenant_email_credentials);

  useEffect(() => {
    if (update_tenant_email_credentials_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_email_credentials_listener.status === app_consts.LOADING)
      {
        setEmailProiver_loading(true);
        setEmailProviderError("");
      } else
      {
        setEmailProiver_loading(false);
        if (update_tenant_email_credentials_listener.status === app_consts.FAIL)
        {
          setEmailProviderError(update_tenant_email_credentials_listener.message);
          messageToast(update_tenant_email_credentials_listener.message, app_consts.FAIL);
        } else if (update_tenant_email_credentials_listener.status === app_consts.SUCCESS)
        {
          messageToast(update_tenant_email_credentials_listener.message, app_consts.SUCCESS);
          retrive_system_settings();
          close_email_provider_modal();
        }
        dispatch(reset_update_tenant_email_credentials());
      }
    }
  }, [update_tenant_email_credentials_listener]);


  const open_sms_provider_modal = () => {
    setSmsProviderModal(true);
    setSmsProviderError("");
    setSmsProviderFormData({ ...sms_provider_formData, ["sms_provider"]: sms_provider_formData?.settings?.sms_provider, ["sms_sender_id"]: sms_provider_formData?.settings?.sms_sender_id, ["password"]: "" });

  };

  const close_sms_provider_modal = () => {
    setSmsProviderModal(false);
    setSmsProviderError("");
    setSmsProviderFormData({ ...sms_provider_formData, ["sms_provider"]: "", ["sms_sender_id"]: "", ["password"]: "" });

  };

  const handleUpdateSmsCredentials = () => {
    setSmsProviderError("");

    dispatch(tenant_auth_actions_helper(loading_update_tenant_sms_credentials, success_update_tenant_sms_credentials, fail_update_tenant_sms_credentials, UPDATE_TENANT_SMS_CREDENTIALS_ERROR_MSG, UPDATE_TENANT_SMS_CREDENTIALS_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${UPDATE_TENANT_SMS_CREDENTIALS_API}`, sms_provider_formData));
  };
  // Listener
  const update_tenant_sms_credentials_listener = useSelector((state) => state.update_tenant_sms_credentials.update_tenant_sms_credentials);

  useEffect(() => {
    if (update_tenant_sms_credentials_listener.status !== app_consts.IDLE)
    {
      if (update_tenant_sms_credentials_listener.status === app_consts.LOADING)
      {
        setSmsProiver_loading(true);
        setSmsProviderError("");
      } else
      {
        setSmsProiver_loading(false);
        if (update_tenant_sms_credentials_listener.status === app_consts.FAIL)
        {
          setSmsProviderError(update_tenant_sms_credentials_listener.message);
          messageToast(update_tenant_sms_credentials_listener.message, app_consts.FAIL);
        } else if (update_tenant_sms_credentials_listener.status === app_consts.SUCCESS)
        {
          messageToast(update_tenant_sms_credentials_listener.message, app_consts.SUCCESS);
          retrive_system_settings();
          close_sms_provider_modal();
        }
        dispatch(reset_update_tenant_sms_credentials());
      }
    }
  }, [update_tenant_sms_credentials_listener]);

  const open_view_ready_dispatch_notifications_modal = () => {
    setReadyForDispatchNotifications(true);
  };

  const close_view_ready_dispatch_notifications_modal = () => {
    setReadyForDispatchNotifications(false);
  };

  const open_view_brands_modal = () => {
    setViewBrandsModal(true);
  };

  const close_view_brands_modal = () => {
    setViewBrandsModal(false);
  };

  const open_stock_movement_suspension_modal = () => {
    setStockMovementSuspensionModal(true);
  };

  const close_stock_movement_suspension_modal = () => {
    setStockMovementSuspensionModal(false);
  };


  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Settings` : "Settings"} />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle page>Settings</BlockTitle>
          </BlockHeadContent>
        </BlockHead>

        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Settings..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    <Block>
                      <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                    </Block>
                    {
                      settings && (settings?.length > 0 || settings?.length !== null) ?
                        <>
                          {
                            activeCardTab === "Main Info" && (
                              <>
                                <PreviewAltCard>
                                  <Row className="pb-5">
                                    <Col lg={6}>
                                      {
                                        logo_settings?.settings?.logo_url ? (
                                          <>
                                            <Card className="product-card" style={{ height: "350px" }}>
                                              <div
                                                className="product-thumb"
                                                style={{
                                                  height: '350px',
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  backgroundColor: '#f9f9f9',
                                                  border: '1px dashed #ccc',
                                                }}
                                              >
                                                <img
                                                  src={logo_settings?.settings?.logo_url}
                                                  alt="Logo"
                                                  style={{
                                                    maxHeight: '90%', // Keeps it inside the box
                                                    maxWidth: '90%',
                                                    objectFit: 'contain',
                                                    display: 'block',
                                                  }}
                                                />
                                              </div>
                                            </Card>
                                            <div className="mt-4 d-flex justify-content-end">
                                              <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                                Update Logo
                                              </Button>
                                            </div>
                                          </>
                                        ) : (
                                          <Card className="product-card" style={{ height: '100%' }}>
                                            <div className="product-thumb" style={{ height: '100%' }}>
                                              <div style={{
                                                width: '100%',
                                                height: '100%',  // Take 100% of the container height
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                backgroundColor: '#f0f0f0', // Light gray background
                                                textAlign: 'center',
                                                border: '1px dashed #ccc', // Dashed border to simulate placeholder
                                                fontSize: '18px', // Font size
                                                fontWeight: 'bold', // Make the text bold
                                                fontFamily: 'Arial, sans-serif', // Custom font
                                                flexDirection: "column"
                                              }}>
                                                <div style={{
                                                  display: 'flex',
                                                  justifyContent: 'center',
                                                  alignItems: 'center',
                                                  textAlign: 'center',
                                                  color: '#333', // Text color
                                                  fontSize: '18px', // Font size
                                                  fontWeight: 'bold', // Make the text bold
                                                  fontFamily: 'Arial, sans-serif', // Custom font
                                                }}>
                                                  <p style={{ margin: 0, padding: '5px' }}>YOUR</p>
                                                  <p style={{ margin: 0, padding: '5px' }}>LOGO</p>
                                                  <p style={{ margin: 0, padding: '5px' }}>HERE</p>
                                                </div>
                                                <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                                  Upload Logo
                                                </Button>
                                              </div>
                                            </div>
                                          </Card>
                                        )
                                      }
                                    </Col>
                                    <Col lg={6}>
                                      <form className="gy-3 form-settings">
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label" htmlFor="site-name">
                                                Name
                                              </label>
                                              <span className="form-note">Name to be used through out the System</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input disabled type="text" className="form-control" id="site-name" defaultValue={settings?.tenant?.name} />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Website URL</label>
                                              <span className="form-note">URL to Access the System</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  value={`${window.location.origin}/${settings?.tenant?.url_prefix}`}
                                                  disabled
                                                  id="site-url"
                                                  readOnly
                                                />
                                                <button
                                                  type="button"
                                                  onClick={() => {
                                                    navigator.clipboard.writeText(
                                                      `${window.location.origin}/${settings?.tenant?.url_prefix}`
                                                    );
                                                    messageToast("Copied to Clipboard", app_consts.SUCCESS);
                                                  }}
                                                  style={{
                                                    background: "none",
                                                    border: "none",
                                                    marginLeft: "10px",
                                                    cursor: "pointer",
                                                  }}
                                                  title="Copy to clipboard"
                                                >
                                                  <Icon name="copy" style={{ height: 30, width: 30 }} />
                                                </button>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Webstore URL</label>
                                              <span className="form-note">URL to Access the Webstore</span>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap d-flex align-items-center">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  value={`${window.location.origin}/${settings?.tenant?.url_prefix}/webstore`}
                                                  disabled
                                                  id="site-url"
                                                  readOnly
                                                />
                                                <button
                                                  type="button"
                                                  onClick={() => {
                                                    navigator.clipboard.writeText(
                                                      `${window.location.origin}/${settings?.tenant?.url_prefix}/webstore`
                                                    );
                                                    messageToast("Copied to Clipboard", app_consts.SUCCESS);
                                                  }}
                                                  style={{
                                                    background: "none",
                                                    border: "none",
                                                    marginLeft: "10px",
                                                    cursor: "pointer",
                                                  }}
                                                  title="Copy to clipboard"
                                                >
                                                  <Icon name="copy" style={{ height: 30, width: 30 }} />
                                                </button>
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Email Address</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.tenant?.email_address}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Mobile Number</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.tenant?.mobile_number}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <div className="mt-4 ">
                                          <BlockHead>
                                            <BlockTitle tag="h6">Contact Details</BlockTitle>
                                          </BlockHead>
                                        </div>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Name</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.user?.first_name ? `${settings?.user?.first_name} ${settings?.user?.last_name}` : "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Email Address</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.account?.email_address || "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                        <Row className="g-3 align-center">
                                          <Col lg="5">
                                            <div className="form-group">
                                              <label className="form-label">Mobile Number</label>
                                            </div>
                                          </Col>
                                          <Col lg="7">
                                            <div className="form-group">
                                              <div className="form-control-wrap">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  name="site-url"
                                                  defaultValue={settings?.account?.mobile_number || "--"}
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          </Col>
                                        </Row>
                                      </form>
                                    </Col>
                                  </Row>
                                </PreviewAltCard>
                                <Modal isOpen={upload_logo_modal} className="modal-dialog-centered" size={"lg"}>
                                  <ModalHeader toggle={!upload_logo_loading && close_upload_logo_modal}>Upload Logo</ModalHeader>
                                  <ModalBody>
                                    <div className="product-thumb" style={{ height: '250px', width: '100%', position: 'relative' }}>
                                      {formData.tenant_logo ? (
                                        <>
                                          <img
                                            src={URL.createObjectURL(formData.tenant_logo)}
                                            alt="Uploaded Logo"
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                          />
                                        </>
                                      ) : (
                                        <label htmlFor="imageUpload" style={{
                                          width: '100%',
                                          height: '100%',
                                          display: 'flex',
                                          justifyContent: 'center',
                                          alignItems: 'center',
                                          backgroundColor: '#f0f0f0',
                                          textAlign: 'center',
                                          border: '1px dashed #ccc',
                                          fontSize: '18px',
                                          fontWeight: 'bold',
                                          fontFamily: 'Arial, sans-serif',
                                          flexDirection: "column",
                                          cursor: 'pointer'
                                        }}>
                                          <p style={{ margin: 0, padding: '5px' }}>Click to Select Image</p>
                                        </label>
                                      )}

                                      <input
                                        type="file"
                                        id="imageUpload"
                                        accept="image/png, image/jpeg, image/jpg"
                                        style={{ display: 'none' }}
                                        onChange={handleImageUpload}
                                      />
                                    </div>

                                    {upload_logo_error && (
                                      <div className="mb-3 w-100 mt-4">
                                        <Alert color="danger" className="alert-icon">
                                          <Icon name="alert-circle" /> {upload_logo_error}{" "}
                                        </Alert>
                                      </div>
                                    )}
                                    <div className={`d-flex flex-row ${formData?.tenant_logo ? "justify-content-between" : "justify-content-end"} mt-4`}>
                                      {
                                        formData?.tenant_logo && (
                                          <>
                                            <Button color="primary" size="md" onClick={open_upload_logo_modal}>
                                              Re-upload
                                            </Button>
                                          </>
                                        )
                                      }
                                      <Button color="success" size="md" onClick={handle_logo_submit} disabled={!formData?.tenant_logo}>
                                        {upload_logo_loading ? "Uploading Logo..." : "Upload Logo"}
                                      </Button>
                                    </div>
                                  </ModalBody>
                                </Modal>
                              </>
                            )
                          }
                          {
                            activeCardTab === "Integrations" && (
                              <>
                                <Block className='my-3'>
                                  <Row className="g-gs">
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="emails" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Emailing Service</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Email Provider: </span> <span>{email_provider_settings?.settings?.email_provider || "Not Set"}</span>
                                              </span>
                                              <span className="release">
                                                <span className="text-soft">Email Address: </span> <span>{email_provider_settings?.settings?.email_address || "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_email_provider_modal} color={email_provider_settings?.email_provider ? "Active" : "primary"}>
                                            Update
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="emails" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Bulk SMS Service</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">SMS Provider: </span> <span>{sms_provider_formData?.settings?.sms_provider || "Not Set"}</span>
                                              </span>
                                              <span className="release">
                                                <span className="text-soft">Sender ID: </span> <span>{sms_provider_formData?.settings?.sms_sender_id || "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_sms_provider_modal} color={sms_provider_formData?.sms_provider ? "Active" : "primary"}>
                                            Update
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Block>

                                <Modal isOpen={email_provider_modal} className="modal-dialog-centered" size={"md"}>
                                  <ModalHeader toggle={!email_provider_loading && close_email_provider_modal}>Update Email Provider Settings</ModalHeader>
                                  <ModalBody>
                                    <Row className="g-4">
                                      <TextInput
                                        label="Email Address"
                                        type="email"
                                        required
                                        id_val="email_provider_email_address"
                                        value={email_provider_formData?.email_address}
                                        colSize="6"
                                        name="email_provider_email_address"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["email_address"]: e.target.value })}
                                      />
                                      <Col lg={6}>
                                        <div className="form-group">
                                          <div className="form-label-group">
                                            <label className="form-label">
                                              <label className="form-label mb text-md" htmlFor="retrunable">
                                                Email Provider<span className='text-danger pr-2'>{` *`}</span>
                                              </label>
                                            </label>
                                          </div>
                                          <div className="w-100">
                                            <RSelect
                                              options={[{ label: "Zoho", value: "zoho" }]?.map((p) => {
                                                return (
                                                  {
                                                    label: p?.label,
                                                    value: p?.value
                                                  }
                                                );
                                              })}
                                              className="w-100"
                                              placeholder="Search"
                                              onChange={(e) => { setEmailProviderFormData({ ...email_provider_formData, email_provider: e?.value }); }}
                                            />
                                          </div>
                                        </div>
                                      </Col>
                                      <TextInput
                                        label="Password"
                                        type="password"
                                        required
                                        id_val="email_provider_password"
                                        value={email_provider_formData?.password}
                                        colSize="6"
                                        name="email_provider_password"
                                        handleChange={(e) => setEmailProviderFormData({ ...email_provider_formData, ["password"]: e.target.value })}
                                      />
                                      {email_provider_error && (
                                        <div className="mb-3 w-100">
                                          <Alert color="danger" className="alert-icon">
                                            <Icon name="alert-circle" /> {email_provider_error}{" "}
                                          </Alert>
                                        </div>
                                      )}
                                      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                        <Button
                                          onClick={handleUpdateEmailCredentials}
                                          disabled={email_provider_loading ||
                                            !(email_provider_formData?.email_address?.trim() &&
                                              email_provider_formData?.email_provider?.trim() &&
                                              email_provider_formData?.password?.trim())}
                                          color="primary"
                                        >
                                          {email_provider_loading ? <Spinner size="sm" color="light" /> : "Update Email Credentials"}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </ModalBody>
                                </Modal>

                                <Modal isOpen={sms_provider_modal} className="modal-dialog-centered" size={"md"}>
                                  <ModalHeader toggle={!sms_provider_loading && close_sms_provider_modal}>Update Bulk SMS Provider Settings</ModalHeader>
                                  <ModalBody>
                                    <Row className="g-4">
                                      <TextInput
                                        label="SMS Provider"
                                        type="text"
                                        required
                                        id_val="sms_provider"
                                        value={sms_provider_formData?.sms_provider}
                                        colSize="6"
                                        name="sms_provider"
                                        handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["sms_provider"]: e.target.value })}
                                      />
                                      {
                                        sms_provider_formData?.sms_provider?.toLowerCase() === "zamtel" && (
                                          <>
                                            <TextInput
                                              label="Sender ID"
                                              type="text"
                                              required
                                              id_val="sms_sender_id"
                                              value={sms_provider_formData?.sms_sender_id}
                                              colSize="6"
                                              name="sms_sender_id"
                                              handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["sms_sender_id"]: e.target.value })}
                                            />
                                            <TextInput
                                              label="API Key"
                                              type="password"
                                              required
                                              id_val="sender_api_key"
                                              value={sms_provider_formData?.password}
                                              colSize="6"
                                              name="sender_api_key"
                                              handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["password"]: e.target.value })}
                                            />
                                          </>
                                        )
                                      }
                                      {
                                        sms_provider_formData?.sms_provider?.toLowerCase() === "mtn" && (
                                          <>
                                            <TextInput
                                              label="Smpp Host"
                                              type="text"
                                              required
                                              id_val="smpp_host"
                                              value={sms_provider_formData?.smpp_host}
                                              colSize="6"
                                              name="smpp_host"
                                              handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["smpp_host"]: e.target.value })}
                                            />
                                            <TextInput
                                              label="Smpp Port"
                                              type="text"
                                              required
                                              id_val="smpp_port"
                                              value={sms_provider_formData?.smpp_port}
                                              colSize="6"
                                              name="smpp_port"
                                              handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["smpp_port"]: e.target.value })}
                                            />
                                            <TextInput
                                              label="System ID"
                                              type="text"
                                              required
                                              id_val="system_id"
                                              value={sms_provider_formData?.system_id}
                                              colSize="6"
                                              name="system_id"
                                              handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["system_id"]: e.target.value })}
                                            />
                                            <TextInput
                                              label="System Type"
                                              type="text"
                                              required
                                              id_val="system_type"
                                              value={sms_provider_formData?.system_type}
                                              colSize="6"
                                              name="system_type"
                                              handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["system_type"]: e.target.value })}
                                            />
                                            <TextInput
                                              label="Password"
                                              type="text"
                                              required
                                              id_val="password"
                                              value={sms_provider_formData?.password}
                                              colSize="6"
                                              name="password"
                                              handleChange={(e) => setSmsProviderFormData({ ...sms_provider_formData, ["password"]: e.target.value })}
                                            />
                                          </>
                                        )
                                      }

                                      {email_provider_error && (
                                        <div className="mb-3 w-100">
                                          <Alert color="danger" className="alert-icon">
                                            <Icon name="alert-circle" /> {email_provider_error}{" "}
                                          </Alert>
                                        </div>
                                      )}
                                      <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
                                        <Button
                                          onClick={handleUpdateSmsCredentials}
                                          disabled={sms_provider_loading ||
                                            sms_provider_formData?.sms_provider?.toLowerCase() === "mtn" ? !(sms_provider_formData?.sms_provider?.trim() &&
                                              sms_provider_formData?.password?.trim() &&
                                              sms_provider_formData?.smpp_port?.trim() &&
                                              sms_provider_formData?.smpp_host?.trim() &&
                                              sms_provider_formData?.system_id?.trim() &&
                                              sms_provider_formData?.system_type?.trim() &&
                                              sms_provider_formData?.password?.trim())
                                            :
                                            !(sms_provider_formData?.sms_provider?.trim() &&
                                              sms_provider_formData?.sms_sender_id?.trim() &&
                                              sms_provider_formData?.password?.trim())}
                                          color="primary"
                                        >
                                          {sms_provider_loading ? <Spinner size="sm" color="light" /> : "Update SMS Credentials"}
                                        </Button>
                                      </Col>
                                    </Row>
                                  </ModalBody>
                                </Modal>
                              </>
                            )
                          }

                          {
                            activeCardTab === "Miscellaneous" && (
                              <>
                                <Block className='my-3'>
                                  <Row className="g-gs">
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="truck" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Ready for Dispatch Notifications</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Set: </span> <span>{ready_for_dispatch_notifications_settings?.settings?.employees && ready_for_dispatch_notifications_settings?.settings?.employees?.length > 0 ? "SET" : "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_view_ready_dispatch_notifications_modal} color={ready_for_dispatch_notifications_settings?.settings?.employees && ready_for_dispatch_notifications_settings?.settings?.employees?.length > 0 ? "Active" : "primary"}>
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="umbrela" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Brands</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Set: </span> <span>{system_brands?.settings?.brands && system_brands?.settings?.brands?.length > 0 ? "SET" : "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_view_brands_modal} color={system_brands?.settings?.brands && system_brands?.settings?.brands?.length > 0 ? "Active" : "primary"}>
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                    <Col xxl="6" key={module.id}>
                                      <div className="nk-download">
                                        <div className="data">
                                          <div className="thumb">
                                            <Icon name="stop" style={{ fontSize: "32px" }} />
                                          </div>
                                          <div className="info">
                                            <h6 className="title">
                                              <span className="name">Suspend System Stock Movement</span>{" "}
                                            </h6>
                                            <div className="meta">
                                              <span className="version">
                                                <span className="text-soft">Set: </span> <span>{stock_movement_suspension_settings?.settings ? "SET" : "Not Set"}</span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="actions">
                                          <Button onClick={open_stock_movement_suspension_modal} color={stock_movement_suspension_settings ? "Active" : "primary"}>
                                            View
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>
                                  </Row>
                                </Block>
                                <ViewDispatchNotificationsModal isOpen={view_ready_dispatch_notifications_modal} closeModal={close_view_ready_dispatch_notifications_modal} tenant_info={tenant_info} user_info={user_info} successFunction={retrive_system_settings} />
                                <ViewBrandsSettingsModal isOpen={view_brands_modal} closeModal={close_view_brands_modal} tenant_info={tenant_info} user_info={user_info} successFunction={retrive_system_settings} />
                                {/* View Suspension Settings Modal */}
                                <ViewStockMovementSuspensionSettingsModal isOpen={stock_movement_suspension_modal} closeModal={close_stock_movement_suspension_modal} tenant_info={tenant_info} user_info={user_info} successFunction={retrive_system_settings} />
                              </>
                            )
                          }
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Settings Found"} />
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default SettingsManagement;